<script>
    import Common from "../common/index";
    // import * as commonServer from "../../../../../../api/common";

    export default {
        name: "moshi",
        mixins: [Common],
        watch: {
            show:{
                handler(vl) {
                    if (vl) {
                        this.init()
                    }
                },
                deep: true,
                immediate: true
            }
        },
        data(){
            return {
                type: 'template',
                config: [
                    {
                        type: 'SearchBox',
                        value: '',
                        fixed: true
                    },
                    {
                        type: 'TypeBtn',
                        value: '',
                        selected: '2',
                        fixed: true
                    },
                    {
                        type: 'CatalogType',
                        value: '',
                        selected: '',
                        fixed: true
                    },
                    {
                        type: 'TypeList',
                        form: [
                            // {
                            //     title: '模式效果1',
                            //     data: [
                            //         {url: this.$images.contents.datu, love: false},
                            //         {url: this.$images.contents.datu, love: true},
                            //         {url: this.$images.contents.datu, love: false},
                            //         {url: this.$images.contents.datu, love: false},
                            //         {url: this.$images.contents.datu, love: false},
                            //         {url: this.$images.contents.datu, love: false},
                            //     ],
                            //     column: 3,
                            // },
                            // {
                            //     title: '模式效果2',
                            //     data: [
                            //         {url: this.$images.contents.datu, love: false},
                            //         {url: this.$images.contents.datu, love: true},
                            //         {url: this.$images.contents.datu, love: false},
                            //         {url: this.$images.contents.datu, love: false},
                            //         {url: this.$images.contents.datu, love: false},
                            //         {url: this.$images.contents.datu, love: false},
                            //     ],
                            //     column: 3,
                            // },
                        ],
                        selected: [0]
                    },
                    {
                        type: 'SearchList',
                        value: ''
                    },
                    {
                        type: 'MoreBtn',
                        value: ''
                    },
                ]
            }
        },
        methods:{
            onSearchBox(search){
                this.search = search
                // this.flashData()
            }
        }
    }
</script>
